import {
  Box,
  Button,
  Menu,
  MenuItem,
  ButtonGroup,
  Card,
  Checkbox,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Search as SearchIcon, Download as ExportIcon } from 'react-feather';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PerfectScrollbar from 'react-perfect-scrollbar';
import moment from 'moment';
import CustomButton from 'src/components/common/customButton';

const CreateAppointmentEmployeeResult = ({
  totalCount,
  onPaginationChange,
  exportFile,
  displayEmployees,
  allEmployees,
  activeBookings,
  activeTable,
  ...props
}) => {
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0);
  const [exportType, setExportType] = useState('CSV');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [employees, setEmployees] = useState(
    displayEmployees &&
      displayEmployees.length > 0 &&
      displayEmployees.slice(page * limit, (page + 1) * limit)
  );
  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    if (activeTable == 1) {
      onPaginationChange('limit', event.target.value, activeTable);
    }
    if (activeTable == 0) {
      onPaginationChange('limit', event.target.value, activeTable);
    }
  };

  const fileList = [
    {
      id: 'CSV',
      title: 'csv'
    },
    {
      id: 'XLSX',
      title: 'xlsx'
    }
  ];

  const handleClose = (item) => {
    setAnchorEl(null);
    if (item) {
      setExportType(item.title);
    }
  };

  const setActiveTable = (value) => {
    setLimit(5);
    setPage(0);
    props.setActiveTable(value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    if (activeTable == 1) {
      onPaginationChange('page', newPage, activeTable);
    }
    if (activeTable == 0) {
      onPaginationChange('page', newPage, activeTable);
    }
  };
  return (
    <>
      <Grid container>
        <Grid xs={12} justifyContent="space-between" container item>
          <Grid
            item
            container
            sx={{
              borderRadius: 3,
              border: '1px solid #1778f2',
              width: '152px',
              height: '40px'
            }}
          >
            <CustomButton
              loading={
                props.loading.activeBookings || props.loading.allEmployees
              }
              onClick={() => setActiveTable(0)}
              fontSize={12}
              shadow="false"
              active={activeTable == 0}
              title="Bookings"
              sx={{
                borderRadius: 2,
                height: '100%',
                width: '150px'
              }}
            />
          </Grid>
          <Grid
            item
            container
            sx={{
              width: '180px'
            }}
          >
            <ButtonGroup
              variant="text"
              disabled={false}
              sx={{ boxShadow: '0 0 4px rgba(0,0,0,0.20)', borderRadius: 15 }}
            >
              <Button
                sx={{ px: 2 }}
                onClick={() => exportFile(exportType)}
                startIcon={<ExportIcon size="18" />}
              >
                Export
              </Button>
              <Button
                onClick={(e) => setAnchorEl(e.currentTarget)}
                endIcon={<ArrowDropDownIcon />}
              >
                {exportType}
              </Button>
            </ButtonGroup>
          </Grid>
          <Menu
            id="export-menu"
            open={open}
            anchorEl={anchorEl}
            onClose={() => handleClose()}
            MenuListProps={{
              'aria-labelledby': 'exporttypeMenu'
            }}
          >
            {fileList.map((menu) => (
              <MenuItem key={menu.id} onClick={() => handleClose(menu)}>
                {menu.title}
              </MenuItem>
            ))}
          </Menu>
        </Grid>
        <Grid xs item>
          <Card
            elevation={0}
            sx={{
              mt: 2
            }}
          >
            <PerfectScrollbar>
              <Box sx={{ minWidth: activeTable ? 1800 : 1000 }}>
                <TableContainer sx={{ maxHeight: 500 }}>
                  <Table
                    stickyHeader
                    aria-label="Employee list"
                    id="employee-list"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell padding="checkbox">
                          <Checkbox
                            sx={{
                              '& .MuiSvgIcon-root': {
                                fontSize: 18
                              }
                            }}
                            color="primary"
                          />
                        </TableCell>
                        <TableCell sx={{ width: 115 }}>Employee ID</TableCell>
                        <TableCell>Appointment ID</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Phone</TableCell>
                        <TableCell>Appointment Date</TableCell>
                        <TableCell>Provider Name</TableCell>
                        <TableCell>Current Status</TableCell>
                        <TableCell>Gender</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>Age</TableCell>
                        <TableCell>Location</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(displayEmployees.length > 0
                        ? displayEmployees
                        : displayEmployees.slice(
                            page * limit,
                            (page + 1) * limit
                          )
                      ).map((employee, idx) => (
                        <TableRow hover key={idx}>
                          <TableCell padding="checkbox">
                            <Checkbox
                              color="primary"
                              sx={{
                                '& .MuiSvgIcon-root': {
                                  fontSize: 18
                                }
                              }}
                              value="true"
                            />
                          </TableCell>
                          <TableCell>{employee.employeeId}</TableCell>
                          <TableCell>{employee.AppointmentId}</TableCell>
                          <TableCell>
                            <Box
                              sx={{
                                alignItems: 'center',
                                display: 'flex'
                              }}
                            >
                              <Typography color="textPrimary" variant="body1">
                                {employee.patientName}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>{employee.emailId}</TableCell>
                          <TableCell>{employee.phoneNumber}</TableCell>
                          <TableCell>
                            {moment(employee.appointmentDate).format(
                              'DD/MM/YYYY'
                            )}
                          </TableCell>
                          <TableCell>
                            {moment(employee.appointmentStatus).format(
                              'DD/MM/YYYY'
                            )}
                          </TableCell>
                          <TableCell>{employee.providerName}</TableCell>
                          <TableCell>{employee.currentStatusName}</TableCell>
                          <TableCell>{employee.gender}</TableCell>
                          <TableCell>{employee.campType}</TableCell>
                          <TableCell>{employee.age}</TableCell>
                          <TableCell>{employee.clientLocation}</TableCell>
                          <TableCell>{employee.appointmentConfirmationDate}</TableCell>
                          <TableCell>{employee.dcName}</TableCell>
                          <TableCell>{employee.appointmentStatus}</TableCell>
                          <TableCell>{employee.dcLocation}</TableCell>
                          <TableCell>{employee.testName}</TableCell>
                          <TableCell>{employee.corporateName}</TableCell>
                          <TableCell>{employee.appointmentConfirmationDate}</TableCell>
                          <TableCell>{employee.appointmentConfirmationTAT}</TableCell>
                          <TableCell>{employee.appointmentReScheduleDate1}</TableCell>
                          <TableCell>{employee.appointmentReScheduleDate2}</TableCell>
                          <TableCell>{employee.appointmentReScheduleDate3}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </PerfectScrollbar>
            <TablePagination
              component="div"
              count={totalCount}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleLimitChange}
              page={page}
              rowsPerPage={limit}
              rowsPerPageOptions={[5, 10, 25]}
            />
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default CreateAppointmentEmployeeResult;
